module.exports = __webpack_public_path__ + "static/img/icon.1691dca4.png";